import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { AuthProvider } from './auth/AuthContext';
import { AppRouter } from './router/AppRouter';
import { SocketProvider } from './context/SocketContext';
import { UsersProvider } from './context/user/ContextUser';
import { RedProvider } from './context/connection/ContextRed';
import { ContextProviderInfo } from './context/ContextInfo';
import './assets/scss/Saas.scss';
moment.locale('es');
export const MainApp = () => {
    return (
        <ContextProviderInfo>
            <RedProvider>
                <UsersProvider>
                    <AuthProvider>
                        <SocketProvider>
                            <AppRouter />
                        </SocketProvider>
                    </AuthProvider>
                </UsersProvider>
            </RedProvider>
        </ContextProviderInfo>
    );
};
